import { createElementBlock, openBlock, createElementVNode } from 'vue';

const _hoisted_1 = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M10.4314 8.43457L16.0179 2.84805C16.2831 2.58338 16.4322 2.22423 16.4325 1.8496C16.4329 1.47497 16.2844 1.11556 16.0197 0.850421C15.755 0.585286 15.3959 0.436149 15.0212 0.435818C14.6466 0.435487 14.2872 0.58399 14.0221 0.848657L8.43555 6.43518L2.84902 0.848657C2.58389 0.583522 2.22429 0.43457 1.84933 0.43457C1.47437 0.43457 1.11477 0.583522 0.849634 0.848657C0.584499 1.11379 0.435547 1.47339 0.435547 1.84835C0.435547 2.22331 0.584499 2.58291 0.849634 2.84805L6.43616 8.43457L0.849634 14.0211C0.584499 14.2862 0.435547 14.6458 0.435547 15.0208C0.435547 15.3957 0.584499 15.7553 0.849634 16.0205C1.11477 16.2856 1.47437 16.4346 1.84933 16.4346C2.22429 16.4346 2.58389 16.2856 2.84902 16.0205L8.43555 10.434L14.0221 16.0205C14.2872 16.2856 14.6468 16.4346 15.0218 16.4346C15.3967 16.4346 15.7563 16.2856 16.0215 16.0205C16.2866 15.7553 16.4355 15.3957 16.4355 15.0208C16.4355 14.6458 16.2866 14.2862 16.0215 14.0211L10.4314 8.43457Z" }, null, -1)
  ])))
}
const CloseIcon = { render: render };

export { CloseIcon as default, render };
